import React from 'react';

interface PageTitleProps {
  title: string;
  additionalCssClasses?: string;
}

const PageTitle = ({ title, additionalCssClasses = '' }: PageTitleProps) => {
  const lineHeightClasses =
    'leading-[41.22px] md:leading-[66px] lg:leading-[100px] xl:leading-[112.21px]';
  const fontSizeClasses =
    'text-[36px] md:text-[53px] lg:text-[88px] xl:text-[98px]';

  return (
    <h1
      className={`font-bold ${fontSizeClasses} ${lineHeightClasses} ${additionalCssClasses}`}
    >
      {title}
      <span className={`text-green`}>.</span>
    </h1>
  );
};

export default PageTitle;
